import {Layout, List, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {px} from '../../../../../utils';
import {renderIfElse} from '../../../../../utils/Utils';
import CustomCard from './CustomCard';

const CardsList = ({data}) => {
  const renderItem = ({item, index}) => <CustomCard key={index} data={item} />;

  return (
    <Layout style={styles.container}>
      {renderIfElse(
        data && data.length > 0,
        <List
          contentContainerStyle={styles.contentContainer}
          data={data}
          renderItem={renderItem}
        />,
        <Text style={styles.noClassText}>
          {"You don't have class on this day.\nKindly refer the 'Timetable'."}
        </Text>,
      )}
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: px(15),
    width: '100%',
  },
  noClassText: {
    textAlign: 'center',
    marginTop: px(40),
    lineHeight: 22,
    fontSize: px(18),
    fontWeight: '600',
    paddingHorizontal: px(10),
  },
  noClassText2: {
    textAlign: 'center',
    marginTop: px(20),
    fontSize: px(16),
    paddingHorizontal: px(17),
  },
  contentContainer: {
    backgroundColor: 'white',
    paddingHorizontal: px(10),
    paddingTop: px(17),
  },
});

export default CardsList;
